/** This file contains constants used across the project */
export const MODULE_NAME = 'kfone-pa-ui';
export const TRANSLATION_ID = 'frontend';
